export default __webpack_public_path__ + "static/about-us-77ccf99f571c3b12d6f63c512cababe5.jpg";